module.exports = __webpack_public_path__ + "img/kaia.81ab715b.svg";